const encodeUrl = (url) => {
  const divider = url.includes('?') ? '?' : '/';
  const parts = url.split(divider);
  const fileName = parts[parts.length - 1];
  parts[parts.length - 1] = encodeURIComponent(fileName);
  return parts.join(divider);
};

export const serializeParams = (params) => {
  const queryParts = [];

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value) && value.every((item) => Array.isArray(item))) {
      value.forEach((group, i) => {
        group.forEach((id) => {
          queryParts.push(`${key}[${i}][]=${encodeURIComponent(id)}`);
        });
      });
    } else if (Array.isArray(value)) {
      value.forEach((v) => {
        queryParts.push(`${key}[]=${encodeURIComponent(v)}`);
      });
    } else {
      queryParts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  return queryParts.join('&');
};

export default encodeUrl;
